
export default class CozyTooltip extends HTMLElement {

  static get is() { return 'tooltip' }

  constructor() {
    super()
    this.attachShadow({ mode: 'open' })
    this.shadowRoot.innerHTML = `
      <style>
        :host {
          position: relative;
          display: inline-block;
        }
        .trigger {
          cursor: help;
          border-bottom: 1px dotted currentColor;
          font-weight: bold;
        }
        .content {
          visibility: hidden;
          opacity: 0;
          width: max-content;
          max-width: 25em;
          background-color: var(--tooltip-bg, #040020E0);
          color: var(--tooltip-color, #fff);
          text-align: left;
          border: 3px solid var(--tooltip-border, #240157);
          border-radius: 0.25em;
          padding: 0.5em;
          position: absolute;
          z-index: 10;
          bottom: 50%;
          left: 50%;
          transform: translateX(10%) translateY(50%);
          transition: opacity 0.3s;
        }
        :host(:hover) .content {
          visibility: visible;
          opacity: 1;
        }
      </style>
      <span part="trigger" class="trigger">${this.getAttribute('trigger') || '?'}</span>
      <span part="content" class="content">
        <slot></slot>
      </span>
    `
  }

  connectedCallback() {
    if (!this.hasAttribute('role'))
      this.setAttribute('role', 'tooltip')
  }
}
